import { render, staticRenderFns } from "./CancelacionSaldo.vue?vue&type=template&id=fed646f4&"
import script from "./CancelacionSaldo.vue?vue&type=script&lang=js&"
export * from "./CancelacionSaldo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports